<template>
    <div style="width: 35%; margin: 10px">
        <div class="page-title">{{ $f.tc('testCallInbound') }}</div>
        <div class="d-flex">
            <input class="input-custom" type="text" id="mobile" disabled v-model="phoneNumber">
            <button id="connect" class="btn-custom ml-6" disabled>Connect</button>
            <button id="call" class="btn-custom ml-6" disabled>Call</button>
            <button id="hangup" class="btn-custom ml-6" disabled>Hangup</button>
            <button id="disconnect" class="btn-custom ml-6" disabled>Disconnect</button>
        </div>

        <div>
            <div class="mx-2">
                <audio id="remoteAudio" controls style="width: 100%">
                    <p>Your browser doesn't support HTML5 audio.</p>
                </audio>
                <span id="dtmf"></span>
            </div>
            <div class="d-flex my-2">
                <button class="btn-outline mx-2 keypad" disabled>1</button>
                <button class="btn-outline mx-2 keypad" disabled>2</button>
                <button class="btn-outline mx-2 keypad" disabled>3</button>
            </div>
            <div class="d-flex my-2">
                <button class="btn-outline mx-2 keypad" disabled>4</button>
                <button class="btn-outline mx-2 keypad" disabled>5</button>
                <button class="btn-outline mx-2 keypad" disabled>6</button>
            </div>
            <div class="d-flex my-2">
                <button class="btn-outline mx-2 keypad" disabled>7</button>
                <button class="btn-outline mx-2 keypad" disabled>8</button>
                <button class="btn-outline mx-2 keypad" disabled>9</button>
            </div>
            <div class="d-flex my-2">
                <button class="btn-outline mx-2 keypad" disabled>*</button>
                <button class="btn-outline mx-2 keypad" disabled>0</button>
                <button class="btn-outline mx-2 keypad" disabled>#</button>
            </div>
        </div>
    </div>
</template>

<script>

import {mapState} from "vuex";

export default {
    name: "TestCallInbound",
    data() {
        return {
            phoneNumber: ''
        }
    },
    mounted() {
        this.autoGenPhoneNumber()
        let scriptTag = document.createElement('script')
        scriptTag.setAttribute("src", "/assets/webphone/webphone.js")
        document.head.appendChild(scriptTag)
    },
    computed: {
        ...mapState({
            userId: state => state.user.profile.id,
        })
    },
    methods: {
        autoGenPhoneNumber() {
            if (this.userId) {
                this.phoneNumber = "999" + String(this.userId).substring(String(this.userId).length - 7)
            }
        }
    },
    destroyed() {
        localStorage.removeItem("service_number")
        localStorage.removeItem("target")
        localStorage.removeItem("web_socket_server")
        this.$store.dispatch(this.$actionTypes.campaign.IS_CALL_TEST_INBOUND, false)
    },
    watch: {
        userId: {
            deep: true,
            handler: function () {
                this.autoGenPhoneNumber()
            }
        }
    }
}
</script>

<style scoped lang="scss">
audio {
    margin: 8px;
}

body {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

input {
    margin: 0 10px 0 10px;
    padding-left: 8px;
    height: 32px;
    border: 1px solid #D9D9D9;
}

#dtmf {
    margin: 10px;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}
</style>
